import React, {useState, useEffect} from 'react';
import {Form, useLoaderData} from "react-router-dom";
import * as Api from "../../util/Api";

function TransactionsRoute() {
    return (
        <div className="App">
            <div>Ек</div>
        </div>
    );
}

export default TransactionsRoute;
